export class RepresentantEntity {

    id!: number;
    planPreventionId!: number;
    intervenantId: number = -1;
    intervenantEntrepriseId: number = -1;
    intervenantEntrepriseNom!: string;
    sentToDocusign!: boolean;
    docusignEnvelopeId!: number;
    raisonSociale!: string;
    hasSigned!: boolean;
    fonction!: string;
    dateSignature!: string;
    hasSignedEnvelope!: boolean;
    docusignRecipientId!: string;
    email!: string;
	intervenantNom!: string;
	intervenantPrenom!: string;
	
	isIntervenant!: boolean;
	envelopeIndex!: number;
	emailStyle: string = '';
	updatable: boolean = true;
}